(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mn-home-brand"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-mnb-sound]').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = btn.parentElement.querySelector('video');
      if (!v) return;
      v.muted = !v.muted;
      btn.textContent = v.muted ? '🔈' : '🔊';
      btn.setAttribute('aria-label', v.muted ? 'הפעלת קול' : 'השתקה');
      if (!v.muted) v.play();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp-sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bar = document.querySelector('[data-mn-sticky]');
  if (!bar) return;
  const form = document.querySelector('form.product-single__form');
  const realBtn = form && form.querySelector('[data-add-to-cart]');
  if (!form || !realBtn) return;
  const add = bar.querySelector('[data-mnsk-add]');
  const price = bar.querySelector('[data-mnsk-price]');
  const variantEl = bar.querySelector('[data-mnsk-variant]');
  const sync = () => {
    const main = document.querySelector('[data-product-price]');
    if (main) price.innerHTML = '<bdi>' + main.textContent.trim() + '</bdi>';
    const sel = form.querySelector('select[name=id]');
    if (sel && sel.selectedOptions[0]) variantEl.textContent = sel.selectedOptions[0].textContent.split(' - ')[0].trim();
    add.disabled = realBtn.disabled;
    add.textContent = realBtn.disabled ? realBtn.textContent.trim() : add.dataset.cta;
  };
  document.addEventListener('variant:change', sync);
  document.addEventListener('change', e => { if (e.target.closest && e.target.closest('.product-section')) setTimeout(sync, 80); });
  add.addEventListener('click', () => { realBtn.click(); });
  let on = false, ticking = false;
  const setOn = (v) => { if (v === on) return; on = v; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); document.body.classList.toggle('mnsk-pad', on); };
  const check = () => { ticking = false; const r = realBtn.getBoundingClientRect(); setOn(r.bottom < 0); };
  const onScroll = () => { if (!ticking) { ticking = true; setTimeout(check, 60); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-popup"]) return;
  try {
    
(() => {
  const el = document.querySelector('[data-mn-popup]');
  if (!el) return;
  const KEY = 'mn_popup_seen';
  const days = parseInt(el.dataset.days || '14', 10);
  const delay = parseInt(el.dataset.delay || '6', 10) * 1000;
  const posted = /[?&]customer_posted=true/.test(location.search);
  const show = (name) => { el.querySelectorAll('[data-mnp-state]').forEach(n => { n.hidden = n.dataset.mnpState !== name; }); };
  const seen = () => { try { const t = localStorage.getItem(KEY); return t && (Date.now() - parseInt(t, 10)) < days * 864e5; } catch (e) { return false; } };
  const mark = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
  const open = () => { el.hidden = false; document.documentElement.style.overflow = 'hidden'; const f = el.querySelector('input[type=email]'); if (f && !posted && window.innerWidth > 720) setTimeout(() => f.focus(), 300); };
  const close = () => { el.hidden = true; document.documentElement.style.overflow = ''; mark(); };
  el.querySelectorAll('[data-mnp-close]').forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !el.hidden) close(); });
  const copy = el.querySelector('[data-mnp-copy]');
  if (copy) copy.addEventListener('click', () => { const c = el.querySelector('#mnp-code').textContent.trim(); navigator.clipboard && navigator.clipboard.writeText(c); copy.textContent = 'הועתק ✓'; });
  if (posted) { show('success'); open(); mark(); return; }
  show('form');
  if (seen()) return;
  let opened = false;
  const once = () => { if (!opened) { opened = true; open(); } };
  setTimeout(once, delay);
  document.addEventListener('mouseleave', e => { if (e.clientY <= 0 && window.innerWidth > 720) once(); });
})();

  } catch(e) { console.error(e); }
})();
})();
